import { render, staticRenderFns } from "./CreateSubcontractingManagement.vue?vue&type=template&id=54ecd520&scoped=true&"
import script from "./CreateSubcontractingManagement.vue?vue&type=script&lang=js&"
export * from "./CreateSubcontractingManagement.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubcontractingManagement.vue?vue&type=style&index=0&id=54ecd520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecd520",
  null
  
)

export default component.exports